'use client'

import { useId } from 'react'

export function Logo({ size = 28, className }: { size?: number; className?: string }) {
  const gradientId = `nivex-logo-g-${useId()}`
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="0"
          x2="48"
          y2="48"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#93C5FD" />
          <stop offset="100%" stopColor="#444CE7" />
        </linearGradient>
      </defs>
      <rect x="6" y="7" width="7" height="28" rx="1.5" fill={`url(#${gradientId})`} />
      <polygon points="13,7 21,7 35,35 27,35" fill={`url(#${gradientId})`} />
      <rect x="35" y="13" width="7" height="28" rx="1.5" fill={`url(#${gradientId})`} />
      <rect x="35.5" y="3.5" width="5" height="5" rx="1" fill="#A4BCFB" />
    </svg>
  )
}
